module.exports = __webpack_public_path__ + "static/media/ru.133e84d5.svg";